import type { Task, WorkPhase } from "@myapp/contract";
import { AttachmentsCard, ReadonlyField } from "../../../shared/ui";
import { WorkSessionTimes } from "../../../features/work-session";
import { TaskStatusHeader } from "./TaskStatusHeader";

type Props = {
  task: Task;
  statusLabel: string;
  statusColor: string;
  typeLabel: string;
  phase: WorkPhase | null;
  terminText: string;
  terminUnscheduled: boolean;
  deadlineText: string;
  deadlineOverdue: boolean;
  onDiscardTravel?: () => void;
};

/**
 * The whole read-only detail body — the task-page counterpart of `AppointmentDetailFields`. Datum,
 * Abgabefrist and Aufgabentyp all fold into `TaskStatusHeader`, so the body drops from six
 * `FieldWrapper`s (the old page) to three cards.
 */
export const TaskDetailFields = ({
  task,
  statusLabel,
  statusColor,
  typeLabel,
  phase,
  terminText,
  terminUnscheduled,
  deadlineText,
  deadlineOverdue,
  onDiscardTravel,
}: Props) => (
  <>
    <TaskStatusHeader
      task={task}
      statusLabel={statusLabel}
      statusColor={statusColor}
      typeLabel={typeLabel}
      terminText={terminText}
      terminUnscheduled={terminUnscheduled}
      deadlineText={deadlineText}
      deadlineOverdue={deadlineOverdue}
    />

    {task.schedule && (
      <WorkSessionTimes schedule={task.schedule} phase={phase} onDiscardTravel={onDiscardTravel} />
    )}

    {task.description && (
      <ReadonlyField label="Beschreibung" value={task.description} clampLines={4} />
    )}

    <AttachmentsCard appAttachments={task.attachments} />
  </>
);
